<template>
    <div class="container-fluid justify-content-center">

        <compose></compose>

    </div>
</template>

<script>
    import NotificationPop from '../mixins/NotificationPop.js'
    import Channels from "../components/Channels";
    import UpgradeNotification
        from "../mixins/UpgradeNotification";
    import Compose
        from "../components/Compose";

    export default {
        mixins: [NotificationPop, UpgradeNotification],
        components: { Compose },
    }
</script>
